export default __webpack_public_path__ + "static/media/content_heart-react.9ef1822c.gif";